import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import { Observable } from 'rxjs';
import {StorageService} from '../services/storage.service';
import {isPlatformBrowser} from "@angular/common";
import {WindowRef} from "../helpers/windowRef.service";

@Injectable({
  providedIn: 'root'
})
export class NotAuthGuard implements CanActivate {

  constructor(private router: Router,
              @Inject(PLATFORM_ID) private platformId: any,
              private windowRef: WindowRef) {
    StorageService.platformId = platformId;
    StorageService.windowRef = windowRef;
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = StorageService.getItem(StorageService.statics.token);
    if (token) {
      let redirectUrl = StorageService.getJsonItem(StorageService.statics.lastPage)
      if(!redirectUrl){
        let url = (isPlatformBrowser(this.platformId))?this.windowRef?.nativeWindow?.location?.pathname.toString():'';
        if(url.indexOf('auth/activate/')>-1){
          return true;
        }else {
          this.router.navigate(['/web-site/list']);
        }
      } else {
        this.router.navigate([redirectUrl.url], { queryParams:redirectUrl.queryParams });
      }

      return false;
    }
    // not logged in so redirect to login page with the return url
    return true;
  }
}
